import { AppState } from 'types/app';

export const selectInfluencerContent = (state: AppState) => state.influencerContent;
export const selectQueryParams = (state: AppState) => state.router.location.search;
